export const typoQueryKeys = {
    all: (agentId: number) => ["page-typo", "agent", agentId]
} as const;
